import styled from "styled-components";

export const FormGroup = styled.div`
  position: relative;
`;

export const Label = styled.label`
  font-family: ${({ theme }) => theme.fonts.secondary};
  font-size: ${({ theme }) => theme.fontSizes["sm"]};
  font-weight: 700;
  color: ${({ theme }) => theme.colors.black[50]};
  display: block;
  line-height: 20px;
`;

export const InputWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
`;

export const IconWrapper = styled.div`
  position: absolute;
  right: 12px;
  width: 20px;
  height: 20px;
`;

export const SuggestionList = styled.ul`
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  z-index: 999;
  list-style: none;
  margin: 0;
  padding: 0;
  border: 1px solid ${({ theme }) => theme.colors.neutral[200]};
  border-radius: 6px;
  background-color: ${({ theme }) => theme.colors.white};
  max-height: 150px;
  overflow-y: auto;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
`;

export const SuggestionItem = styled.li`
  padding: 10px 12px;
  cursor: pointer;
  font-family: ${({ theme }) => theme.fonts.secondary};
  font-size: ${({ theme }) => theme.fontSizes.sm};
  color: ${({ theme }) => theme.colors.black[100]};
  border-bottom: 1px solid ${({ theme }) => theme.colors.neutral[100]};

  &:hover {
    background-color: ${({ theme }) => theme.colors.neutral[100]};
  }

  &:last-child {
    border-bottom: none;
  }
`;

export const SuggestionWarningItem = styled.li`
  padding: 10px 12px;
  cursor: default;
  pointer-events: none;
  font-family: ${({ theme }) => theme.fonts.secondary};
  font-size: ${({ theme }) => theme.fontSizes.sm};
  color: ${({ theme }) => theme.colors.magenta[400]};
  border-bottom: 1px solid ${({ theme }) => theme.colors.neutral[100]};

  &:last-child {
    border-bottom: none;
  }
`;

export const StyledInput = styled.input<{ hasError?: boolean }>`
  width: 100%;
  padding: 12px 16px;
  border: 2px solid
    ${({ theme, hasError }) =>
      hasError ? theme.colors.magenta[400] : theme.colors.neutral[200]};
  border-radius: 6px;
  gap: 8px;
  font-family: ${({ theme }) => theme.fonts.secondary};
  font-size: ${({ theme }) => theme.fontSizes["sm"]};
  color: ${({ theme }) => theme.colors.black[100]};
  background-color: ${({ theme }) => theme.colors.white};
  transition: border-color 0.2s ease;

  &::placeholder {
    color: ${({ theme }) => theme.colors.neutral[300]};
  }

  &:focus {
    outline: none;
    border-color: ${({ theme, hasError }) =>
      hasError ? theme.colors.magenta[400] : theme.colors.brand[400]};
  }

  &:hover {
    border-color: ${({ theme, hasError }) =>
      hasError ? theme.colors.magenta[400] : theme.colors.neutral[300]};
  }

  &:not(:placeholder-shown) {
    border-color: ${({ theme, hasError }) =>
      hasError ? theme.colors.magenta[400] : theme.colors.neutral[300]};
  }

  &:focus:not(:placeholder-shown) {
    border-color: ${({ theme, hasError }) =>
      hasError ? theme.colors.magenta[400] : theme.colors.brand[400]};
  }
`;
